const state= {

};

const getters = {

};

const actions = {
    async getSContract({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/s-contracts-project`, { params: params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async checkExistingProject({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/s-contracts-project/check-existing-project`, params)
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async generateJobsProject({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/s-contracts-project/generate-jobs-project`, params)
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async getJobs({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/s-contracts-project/jobs`, { params: params })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async importScontractSchedule({commit},params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            formData.append('file_import', params.file_import);
            global.axios.post(`api/s-contracts-project/import`, formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    resolve( response );
                })
                .catch(error =>{
                    reject( error )
                } );
        });
    },
};

const mutations = {

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
